import React, { useState } from "react";
import { toast } from "react-hot-toast";
import { BadgeIcon, ShieldIcon, HashIcon, ChevronDown, ChevronUp, FilterIcon } from "lucide-react";

export default function UsuariosFiltro({ filtros, setFiltros }) {
  const [isFiltroAberto, setIsFiltroAberto] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFiltros((prev) => ({ ...prev, [name]: value }));
  };

  const handleCodigoKeyDown = (e) => {
    const isNumber = /^[0-9]$/;
    if (!isNumber.test(e.key) && !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
      e.preventDefault();
      toast.error("Digite apenas números no campo Código.");
    }
  };

  return (
    <div className="bg-white border border-[#0d1c32] border-[1px] p-3 rounded-lg shadow-md mt-2 mb-6 max-w-7xl mx-auto">
      <div className="flex items-center justify-between cursor-pointer w-auto" onClick={() => setIsFiltroAberto(!isFiltroAberto)}>
        <div className="flex items-center gap-2">
          <FilterIcon className="w-5 h-5 text-blue-500" />
          <span className="text-black font-semibold">Filtro Usuários</span>
        </div>
        <div
          className={`transition-transform duration-300 ease-in-out transform ${isFiltroAberto ? "rotate-180" : ""}`}
          style={{
            backgroundColor: 'blue',
            borderRadius: '50%',
            padding: '4px',
            width: '30px',
            height: '30px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          {isFiltroAberto ? <ChevronUp className="text-white" /> : <ChevronDown className="text-white" />}
        </div>
      </div>

      <div
        className={`overflow-hidden transition-all duration-500 ease-in-out ${isFiltroAberto ? 'opacity-100' : 'opacity-0'}`}
        style={{
          height: isFiltroAberto ? 'auto' : '0px',
          paddingTop: isFiltroAberto ? '10px' : '0px',
          paddingBottom: isFiltroAberto ? '10px' : '0px',
        }}
      >
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mt-2">
          {/* Código */}
          <div className="flex flex-col">
            <label className="text-sm font-medium text-gray-700 flex items-center gap-1 mb-1">
              <HashIcon className="w-4 h-4" />
              Código
            </label>
            <input
              type="text"
              name="codigo"
              placeholder="Digite o código"
              value={filtros.codigo}
              onChange={handleChange}
              onKeyDown={handleCodigoKeyDown}
              className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 outline-none"
            />
          </div>

          {/* Nome */}
          <div className="flex flex-col">
            <label className="text-sm font-medium text-gray-700 flex items-center gap-1 mb-1">
              <BadgeIcon className="w-4 h-4" />
              Nome
            </label>
            <input
              type="text"
              name="nome"
              placeholder="Digite o nome"
              value={filtros.nome}
              onChange={handleChange}
              className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 outline-none"
            />
          </div>

          {/* Função */}
          <div className="flex flex-col">
            <label className="text-sm font-medium text-gray-700 flex items-center gap-1 mb-1">
              <ShieldIcon className="w-4 h-4" />
              Função
            </label>
            <input
              type="text"
              name="funcao"
              placeholder="Digite a função"
              value={filtros.funcao}
              onChange={handleChange}
              className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 outline-none"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
